import { defineStore } from "pinia";

export default defineStore("headerDate", {
    state: () => ({
        yearList: [],
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
    }),
    actions: {
        setYearList(data) {
            this.yearList = data || [];
        },
        setYear(data) {
            this.year = data || "";
        },
        setMonth(data) {
            this.month = data || "";
        },
    },
    persist: {
        enabled: true, // 刷新页面后是否缓存
        strategies: [
            {
                storage: sessionStorage,
            },
        ],
    },
});
